import createNamespaceContext from './helper/createNamespaceContext';
export var LINKING_PLATFORM_CONTEXT = 'linkingPlatformCtx';
export var LinkingPlatformAnalyticsContext = createNamespaceContext(LINKING_PLATFORM_CONTEXT, 'LinkingPlatformAnalyticsContext');